<template>
    <ul class="attachment-list" v-if="hasDocumentAttachment(blockoutDay)">
        <li v-for="(value, docUrlIndex) in getDocumentUrls(blockoutDay.attachments)" :key="docUrlIndex">
            <a :href="value.photoUrl" download target="_blank">
                <md-icon>
                    picture_as_pdf
                </md-icon>

                <md-tooltip md-direction="top">
                    {{ value.photoName }}
                </md-tooltip>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'BlockoutDaysDocument',
    props: {
        blockoutDay: {
            type: Object,
            default: () => {},
            required: true
        },
        hasDocumentAttachment: {
            type: Function,
            required: true
        }
    },
    methods: {
        getDocumentUrls(attachments) {
            return attachments.flatMap((att) => att.documentUrls || []);
        }
    }
};
</script>

<style lang="scss" scoped>
.attachment-list {
    list-style: none;
    padding: 0;
    margin: 0;

    display: flex;
    align-items: center;
    gap: 3px;
    flex-wrap: wrap;

    a {
        cursor: pointer;
        color: black;
        font-size: 13px;
    }
}
</style>
